import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-account-search',
  templateUrl: './account-search.component.html',
  styleUrls: ['./account-search.component.css']
})
export class AccountSearchComponent implements OnInit {

  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialogRef<AccountSearchComponent>
  ) { }

  ngOnInit() {
    this.createForm();
  }
  createForm() {
    this.form = this.fb.group({
      FullName: [null],
      NationalCode: [null],
      PhoneNumber: [null]
    });
  }

  submit(data: any) {
   
    this.dialog.close(data);
  }

  onNoClick() {
    this.dialog.close();
  }


}
